
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { IdentificationTypeResponse } from "../../models/dtos";

export const identificationTypesApi = createApi({
  reducerPath: 'identificationTypesApi',
  baseQuery: baseAuthQuery('IdentificationTypes'),
  tagTypes: ['IdentificationType'],
  endpoints: (builder) => ({
    getIdentificationTypes: builder.query<ApiResponse<IdentificationTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['IdentificationType'],
    }),
    getIdentificationTypeById: builder.query<ApiResponse<IdentificationTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['IdentificationType'],
    }),
    updateIdentificationType: builder.mutation<ApiResponse<IdentificationTypeResponse>, Partial<IdentificationTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['IdentificationType'],
    }),
    deleteIdentificationType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['IdentificationType'],
    }),
  }),
});
